module.exports = __webpack_public_path__ + "sidebar-logo.png?796d5f080dbd724a81d2b5f642ff5fd6";